exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2.slider[data-v-6c948c03] {\n  margin-top: 0;\n}\n.slider[data-v-6c948c03] {\n  overflow-y: hidden;\n  transition-property: all;\n  transition-duration: 0.75s;\n  transition-timing-function: linear;\n}\n.slider.closed[data-v-6c948c03] {\n  max-height: 0!important;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n", ""]);

// exports
